<template>
  <div>
    <!--  infoCardColumn 和 infoCardData 变量名称固定 不然不赋值  -->
    <matrix-card-group :column="infoCardColumn" :data="infoCardData"></matrix-card-group>
    <avue-crud
      ref="crud"
      v-model="form"
      :option="option"
      :table-loading="loading"
      :data="data"
      :page.sync="page"
      :search.sync="query"
      :defaults.sync="defaults"
      @row-save="rowSave"
      @row-update="rowUpdate"
      @row-del="rowDel"
      @search-change="searchChange"
      @search-reset="searchReset"
      @refresh-change="refreshChange"
      @current-change="currentChange"
      @size-change="sizeChange"
      @on-load="onLoad"
    >
    </avue-crud>
  </div>
</template>

<script>
import crudMixins from "@/mixins/crud-mixins";
import {getList, add, update, remove, getDetail} from "./api";
import MatrixCardGroup from "@/components/matrix/matrix-card-group.vue";
import {searchTimeConfig} from "@/basic-common/util/common";

export default {
  components: {MatrixCardGroup},
  mixins: [crudMixins],
  data() {
    return {
      apiConfig: {getList, add, update, remove, getDetail},
      infoCardColumn: [],
      infoCardData: [], // 卡片数据
      option: {
        labelWidth: 100,
        searchLabelWidth: 100,
        column: [
          {
            label: '合同编码',
            prop: 'contractNo',
          },
          {
            label: '合同名称',
            prop: 'contractName',
            search: true, // 查询是否显示
            minWidth: 150, // 表格最小宽度
            type: 'select',
            remote: true,
            allowCreate: true,
            dicUrl: '/api/produce/transport-contract/select/distinct/pycode?name={{key}}',
            props: {
              label: 'contractName',
              value: 'contractName'
            },
          },
          {
            label: '业务类型',
            prop: 'businessType',
            dataType: 'string',
            overHidden: true, // 表格超出隐藏
            type: 'select',
            dicData: this.$store.getters.commonDict['businessType'],
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
          },
          {
            label: '客户编码',
            prop: 'custNo',
          },
          {
            label: '货主',
            prop: 'custNo',
            type: 'select',
            dicUrl: '/api/produce/blade-dept/select/distinct/select',
            search: true, // 查询是否显示
            props: {
              label: 'deptName',
              value: 'id'
            },
          },
          {
            label: '物资编码',
            prop: 'varNo',
          },
          {
            label: '物资名称',
            prop: 'varName',
            search: true, // 查询是否显示
            minWidth: 150, // 表格最小宽度
            type: 'select',
            remote: true,
            allowCreate: true,
            dicUrl: '/api/produce/transport-contract/select/distinct/pycode?name={{key}}',
            props: {
              label: 'varName',
              value: 'varName'
            },
          },
          {
            label: '合同开始日期',
            prop: 'startDate',
          },
          {
            label: '合同结束日期',
            prop: 'endDate',
          },
          {
            label: '风险等级',
            prop: 'riskLevel',
          },
          {
            label: '备注',
            prop: 'remark',
          },
          {
            label: '录入人',
            prop: 'createUser',
          },
          {
            label: '录入人名称',
            prop: 'createName',
            search: true, // 查询是否显示
            minWidth: 150, // 表格最小宽度
            type: 'select',
            remote: true,
            allowCreate: true,
            dicUrl: '/api/produce/transport-contract/select/distinct/pycode?name={{key}}',
            props: {
              label: 'createName',
              value: 'createName'
            },
          },
          {
            label: '录入时间',
            prop: 'contractStartDate',
            type: 'datetime',
            format: 'yyyy-MM-dd HH:mm:ss',
            valueFormat: 'yyyy-MM-dd HH:mm:ss',
            minWidth: 120,
          },
          {
            ...searchTimeConfig,
            paramsKey: ["startTime", "endTime"],
          },
        ]
      },
    }
  }
}
</script>
<style scoped lang="scss">
</style>
